module.exports = __webpack_public_path__ + "static/media/二维码扫码评价系统.74f269e9.png";